import type { NavLinkProps } from "react-router-dom";
import { NavLink } from "react-router-dom";

interface LinkButtonProps {
  label: string;
  to: NavLinkProps["to"];
}

export const LinkButton = ({ label, to }: LinkButtonProps) => (
  <NavLink
    to={to}
    className="text-default hover:text-darkest focus:text-darkest flex items-center rounded-md bg-transparent px-3 py-2 text-sm font-medium leading-5 outline-none"
    activeClassName="bg-secondary !text-darkest font-semibold"
  >
    {label}
  </NavLink>
);
